import React, { useState, useEffect } from "react";
import HourlyPlatesStackedChart from "../components/HourlyPlatesStackedChart";
import { authFetch } from "../utils/authFetch";
import API_ENDPOINTS from "../apiConfig";
import { useSite } from "../context/SiteContext";
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";

function Statistics() {
    const { selectedSite, siteId, areas: loadedAreas } = useSite(); // areas already loaded in dashboard
    const [combinedData, setCombinedData] = useState([]);
    const [areaNames, setAreaNames] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();

    const selectedDate = new Date().toISOString().split("T")[0]; // today: YYYY-MM-DD

    useEffect(() => {

        if (siteId == null) return;

        const fetchStats = async () => {

            try {

                const token = localStorage.getItem("token");

                const res = await authFetch(
                    `${API_ENDPOINTS.getsites}/${siteId}/stats`,
                    { headers: { Authorization: `Bearer ${token}` } }
                );

                const json = await res.json();

                const chartData = Array.from({ length: 24 }, (_, hour) => {

                    let allowed = 0;
                    let notAllowed = 0;

                    Object.keys(json).forEach(areaId => {

                        const dayData = json[areaId][selectedDate] || [];

                        allowed += dayData[hour]?.y || 0;
                        notAllowed += dayData[hour]?.n || 0;

                    });

                    return {
                        hour: `${hour}:00`,
                        allowed,
                        notAllowed
                    };
                });

                setCombinedData(chartData);
                setLoading(false);   // ✅ THIS WAS MISSING

            } catch (err) {

                setError(err.message);
                setLoading(false);   // ✅ also stop loading on error

            }

        };

        fetchStats();

    }, [siteId]);
    if (!siteId) return <p>Please select a site.</p>;
    if (loading) return <p>Loading statistics...</p>;
    if (error) return <p className="text-danger">{error}</p>;

    const totals = combinedData.reduce((acc, curr) => {
        acc.allowed += curr.allowed || 0;
        acc.blocked += curr.notAllowed || 0;
        return acc;
    }, { allowed: 0, blocked: 0 });

    return (
        <div
            className="p-4 border ez-rounded-card bg-white shadow-sm transition-all stats-card"
            style={{ cursor: "pointer" }}
            onClick={() => navigate("/statistics")}
        >
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h4 className="mb-0 d-flex align-items-center gap-2">
                    {t("Statistics")}
                    <button
                        className="btn btn-sm btn-light"
                        onClick={(e) => { e.stopPropagation(); navigate("/statistics"); }}
                        title={t("Statistics details")}
                    >
                        <i className="bi bi-arrow-right-square"></i>
                    </button>
                </h4>
                
                <div className="text-end">
                    <span className="me-3">
                        <small className="text-muted text-uppercase" style={{ fontSize: '0.7rem' }}>{t("Authorized")}: </small>
                        <strong style={{ color: "var(--ez-orange-light)" }}>{totals.allowed}</strong>
                    </span>
                    <span>
                        <small className="text-muted text-uppercase" style={{ fontSize: '0.7rem' }}>{t("Unauthorized")}: </small>
                        <strong className="text-danger">{totals.blocked}</strong>
                    </span>
                </div>
            </div>

            <HourlyPlatesStackedChart data={combinedData} />
            
            {/* Optional: Subtle footer hint */}
            <div className="text-center mt-2">
                <small className="text-muted" style={{ fontSize: '0.75rem' }}>
                    {t("Click for details")}
                </small>
            </div>
        </div>
    );
}

export default Statistics;